import styled from 'styled-components';

import { designColor, styledReset } from '@pkg/primitives';

const tooltipWidth = 280;

export const StyledTooltip = styled.div`
    padding: 16px;
    width: ${tooltipWidth}px;
    border-radius: 10px;
    background-color: ${designColor.coal};
    box-shadow: 0 0 6px ${(props) => props.theme.shades.black['55']};
`;

export const Title = styled.span`
    ${styledReset.typography}
    display: block;
    font-family: 'Alliance No.1';
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    color: ${(props) => props.theme.colors.white};
`;

export const Description = styled.p`
    ${styledReset.typography}
    margin-top: 10px;
    font-family: 'Alliance No.1';
    font-size: 14px;
    line-height: 1.3;
    color: ${(props) => props.theme.shades.white['50']};
`;
